
import React, { useState } from "react";
import { ToastContainer } from "react-toastify";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";

import { successToaster } from "./../../utils/index";
import { useEffect } from "react";
import apiClient from "../../utils/api";

export const CourierForm = () => {
  let courierDetails = {
    state: "",
    g250: "",
    g500: "",
    upto3kg: "",
    above3kg: "",
  };

  const [courierData, setCourierData] = useState(courierDetails);
  const [isChecked, setIsChecked] = useState(0);
  const courierDataHandler = (e) => {
    const courierDataArr = { ...courierData };
    courierDataArr[e.target.name] = e.target.value;
    setCourierData(courierDataArr);
  };

  useEffect(() => {
    apiClient
      .get(`get/free_delivery.php`, {
        params: { sno: "1" }, // Ensure sending params correctly
      })
      .then((response) => {
        if (response.data.length > 0) {
          const fetchedValue = Number(response.data[0].free); // Convert to number
          console.log("Fetched Free Delivery Value:", fetchedValue);
          setIsChecked(fetchedValue);
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, []);
  

  const courierPriceSubmit = async () => {
    apiClient
      .post(`put/delivery_cost.php`, {
        ...courierData,
      })
      .then((res) => {
        setCourierData(courierDetails);
        console.log("success");
        successToaster({ msg: "Price Changed Successful" });
      });
  };

  const handleCheckboxChange = (e) => {
    const value = e.target.checked ? 1 : 0;
    setIsChecked(value);

    // Send updated value to API
    apiClient
      .put(`put/free_delivery.php`, { sno: 1, value })
      .then((response) => {
        console.log("Response:", response.data);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  

  return (
    <>
      <Row className="my-3">
        <h3 className="text-secondary text-uppercase">courier price details</h3>
      </Row>
      <div style={{ display: "flex", paddingBottom: "10px" }}>
      <input
        type="checkbox"
        checked={isChecked === 1} // Ensure strict comparison
        onChange={handleCheckboxChange}
      />
      &nbsp;&nbsp;<span>Free Delivery</span>
    </div>
      <Row className="mb-3">
        <Form.Group as={Col} md="3">
          <Form.Label>Select State</Form.Label>
          <Form.Select
            name="state"
            value={courierData.state}
            onChange={(e) => courierDataHandler(e)}>
            <option>...</option>
            <option value="andaman and nicobar islands">
              Andaman and Nicobar Islands
            </option>
            <option value="andhra pradesh">Andhra Pradesh</option>

            <option value="arunachal pradesh">Arunachal Pradesh</option>
            <option value="assam">Assam</option>
            <option value="bihar">Bihar</option>
            <option value="chandigarh">Chandigarh</option>
            <option value="chhattisgarh">Chhattisgarh</option>
            <option value="dadar and nagar haveli">
              Dadar and Nagar Haveli
            </option>
            <option value="daman and diu">Daman and Diu</option>
            <option value="delhi">Delhi</option>
            <option value="goa">Goa</option>
            <option value="gujarat">Gujarat</option>
            <option value="haryana">Haryana</option>
            <option value="himachal pradesh">Himachal Pradesh</option>
            <option value="jammu and kashmir">Jammu and Kashmir</option>
            <option value="jharkhand">Jharkhand</option>
            <option value="karnataka">Karnataka</option>
            <option value="kerala">Kerala</option>
            <option value="ladakh">Ladakh</option>
            <option value="lakshadweep">Lakshadweep</option>
            <option value="madhya pradesh">Madhya Pradesh</option>
            <option value="maharashtra">Maharashtra</option>
            <option value="manipur">Manipur</option>
            <option value="meghalaya">Meghalaya</option>
            <option value="mizoram">Mizoram</option>
            <option value="nagaland">Nagaland</option>
            <option value="odisha">Odisha</option>
            <option value="puducherry">Puducherry</option>
            <option value="punjab">Punjab</option>
            <option value="rajasthan">Rajasthan</option>
            <option value="sikkim">Sikkim</option>
            <option value="tamilnadu">Tamil Nadu</option>
            <option value="Telangana">Telangana</option>
            <option value="Tripura">Tripura</option>
            <option value="uttar pradesh">Uttar Pradesh</option>
            <option value="uttarakhad">Uttarakhad</option>
            <option value="west bengal">West Bengal</option>
          </Form.Select>
        </Form.Group>
      </Row>
      <Row className="mb-3">
        <Form.Group as={Col} md="3" controlId="validationCustom01">
          <Form.Label>First 250 Gms.</Form.Label>
          <Form.Control
            required
            type="number"
            placeholder="250 Gms"
            name="g250"
            value={courierData.g250}
            onChange={(e) => courierDataHandler(e)}
          />
        </Form.Group>
        <Form.Group as={Col} md="3" controlId="validationCustom02">
          <Form.Label>Upto 500 Gms.</Form.Label>
          <Form.Control
            required
            type="number"
            placeholder="500 Gms"
            name="g500"
            value={courierData.g500}
            onChange={(e) => courierDataHandler(e)}
          />
        </Form.Group>
        <Form.Group as={Col} md="3" controlId="validationCustom02">
          <Form.Label>Every add 500 Gms upto 3KG.</Form.Label>
          <Form.Control
            required
            type="number"
            placeholder="Add 500 Gms Upto 3KG"
            name="upto3kg"
            value={courierData.upto3kg}
            onChange={(e) => courierDataHandler(e)}
          />
        </Form.Group>
        <Form.Group as={Col} md="3" controlId="validationCustom02">
          <Form.Label>Above 3KG Per KG.</Form.Label>
          <Form.Control
            required
            type="number"
            placeholder="Above 3KG"
            name="above3kg"
            value={courierData.above3kg}
            onChange={(e) => courierDataHandler(e)}
          />
        </Form.Group>
      </Row>
      <Button type="submit" onClick={courierPriceSubmit}>
        Submit Courier Price Details
      </Button>
      <ToastContainer />
    </>
  );
};
